"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _isSameMonth = _interopRequireDefault(require("date-fns/isSameMonth"));
var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));
var _subMonths = _interopRequireDefault(require("date-fns/subMonths"));
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _reactDayPicker = require("react-day-picker");
var _constants = require("../../constants");
require("react-day-picker/dist/style.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "au_day_picker-module__container___Hz5ec",
  "daypicker": "au_day_picker-module__daypicker___iGNy2",
  "nav": "au_day_picker-module__nav___vghig",
  "caption": "au_day_picker-module__caption___WO5j0",
  "link": "au_day_picker-module__link___bhvwW",
  "previous": "au_day_picker-module__previous___WnMNp au_day_picker-module__link___bhvwW",
  "next": "au_day_picker-module__next___Jpioz au_day_picker-module__link___bhvwW",
  "disabled": "au_day_picker-module__disabled___N6qvd",
  "hide": "au_day_picker-module__hide___YbBnZ",
  "readonly": "au_day_picker-module__readonly___uqHIu"
};
function CalendarCaption({
  displayMonth
}) {
  const {
    numberOfMonths
  } = (0, _reactDayPicker.useDayPicker)();
  const {
    goToMonth,
    nextMonth,
    previousMonth,
    displayMonths
  } = (0, _reactDayPicker.useNavigation)();
  const displayIndex = (0, _findIndex.default)(displayMonths).call(displayMonths, month => (0, _isSameMonth.default)(displayMonth, month));
  let isFirst = displayIndex === 0;
  let isLast = displayIndex === displayMonths.length - 1;
  const hideNext = numberOfMonths > 1 && (isFirst || !isLast); // !nextMonth || 
  const hidePrevious = numberOfMonths > 1 && (isLast || !isFirst); // !previousMonth || 

  const handlePreviousClick = () => {
    if (!previousMonth) return;
    goToMonth(previousMonth);
  };
  const handleNextClick = () => {
    if (!nextMonth) return;
    goToMonth(nextMonth);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('rdp-nav', styles.nav)
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)(styles.previous, {
      [styles.disabled]: !previousMonth,
      [styles.hide]: hidePrevious
    }),
    onClick: handlePreviousClick
  }, (0, _format.default)((0, _subMonths.default)(displayMonth, 1), 'MMM')), /*#__PURE__*/_react.default.createElement("h2", {
    className: (0, _classnames.default)('rdp-caption', styles.caption)
  }, (0, _format.default)(displayMonth, 'MMMM')), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)(styles.next, {
      [styles.disabled]: !nextMonth,
      [styles.hide]: hideNext
    }),
    onClick: handleNextClick
  }, (0, _format.default)((0, _addMonths.default)(displayMonth, 1), 'MMM')));
}
function formatWeekdayName(date, options) {
  return (0, _format.default)(date, 'EEE', {
    locale: options?.locale
  });
}
class AuDayPicker extends _react.default.Component {
  static propsTypes = {
    mode: T.oneOf(['single', 'multiple']),
    locale: T.object,
    numberOfMonths: T.number,
    month: T.instanceOf(Date),
    initialMonth: T.instanceOf(Date),
    fromDate: T.instanceOf(Date),
    fromMonth: T.instanceOf(Date),
    toDate: T.instanceOf(Date),
    toMonth: T.instanceOf(Date),
    selectedDays: T.array,
    disabledDays: T.array,
    modifiers: T.object,
    fixedWeeks: T.bool,
    canChangeMonth: T.bool,
    onDayClick: T.func,
    onDayMouseEnter: T.func,
    onMonthChange: T.func,
    readOnly: T.bool,
    reverseMonths: T.bool
  };
  static defaultProps = {
    mode: 'single',
    locale: _enUS.default,
    numberOfMonths: 1,
    selectedDays: [],
    disabledDays: [],
    modifiers: {},
    fixedWeeks: true,
    canChangeMonth: false,
    onDayClick: _constants.NOOP,
    onMonthChange: _constants.NOOP,
    onDayMouseEnter: _constants.NOOP,
    onDayMouseLeave: _constants.NOOP,
    readOnly: false,
    reverseMonths: false,
    showOutsideDays: false
  };
  render() {
    const {
      className,
      selectedDays,
      disabledDays,
      modifiers,
      readOnly,
      reverseMonths
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className, {
        [styles.readonly]: readOnly
      })
    }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.DayPicker, {
      mode: this.props.mode,
      className: styles.daypicker,
      month: this.props.month,
      fromDate: this.props.fromDate,
      fromMonth: this.props.fromMonth,
      toMonth: this.props.toMonth,
      toDate: this.props.toDate,
      defaultMonth: this.props.initialMonth,
      numberOfMonths: this.props.numberOfMonths,
      reverseMonths: reverseMonths,
      fixedWeeks: this.props.fixedWeeks,
      disableNavigation: !this.props.canChangeMonth,
      modifiers: modifiers,
      selected: selectedDays,
      disabled: disabledDays,
      locale: this.props.locale,
      onSelect: readOnly ? _constants.NOOP : this.props.onDayClick,
      onMonthChange: readOnly ? _constants.NOOP : this.props.onMonthChange,
      onDayMouseEnter: readOnly ? _constants.NOOP : this.props.onDayMouseEnter,
      onDayMouseLeave: readOnly ? _constants.NOOP : this.props.onDayMouseLeave,
      components: {
        Caption: CalendarCaption
      },
      formatters: {
        formatWeekdayName
      },
      showOutsideDays: this.props.showOutsideDays
    }));
  }
}
exports.default = AuDayPicker;